export const KnownRoles = {
  MitAdmin: 'mit-admin',
  AgencyAdmin: 'agency-admin',
  Dispatcher: 'dispatcher',
  Crew: 'crew',
} as const;

export type KnownRole = (typeof KnownRoles)[keyof typeof KnownRoles];

export const PORTAL_AUTHORIZED_ROLES: readonly string[] = [
  KnownRoles.AgencyAdmin,
  KnownRoles.Crew,
  KnownRoles.Dispatcher,
];
